import React, { useState } from "react";
import { createPortal } from "react-dom";

const TextTooltip = ({ text, customStyle = "", customTextStyle = "", children }) => {
    const [visible, setVisible] = useState(false);
    const [position, setPosition] = useState({ x: 0, y: 0 });

    const handleMouseMove = (e) => {
        const onRight = e.clientX > window.innerWidth / 2;
        setPosition({
            x: e.clientX + (onRight ? -12 : 12),
            y: e.clientY + 12,
            onRight,
        });
    };

    if (!text) return children;

    return (
        <>
            <span
                style={{ display: "inline-block" }}
                className={customStyle}
                onMouseEnter={() => setVisible(true)}
                onMouseLeave={() => setVisible(false)}
                onMouseMove={handleMouseMove}
            >
                {children}
            </span>

            {visible &&
                createPortal(
                    <div
                        className={`capitalize ${customTextStyle}`}
                        style={{
                            position: "fixed",
                            top: position.y,
                            ...(position.onRight
                                ? { right: window.innerWidth - position.x, left: "auto" }
                                : { left: position.x }),
                            background: "#111",
                            color: "#fff",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            fontSize: "12px",
                            pointerEvents: "none",
                            whiteSpace: "nowrap",
                            zIndex: 999999, // now this actually works
                            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                        }}
                    >
                        {text}
                    </div>,
                    document.body
                )}
        </>
    );
};

export default TextTooltip;